import React, { type ComponentProps } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { useResponsive } from '@garnish/core';

import { useA11ySelector } from '@sg/a11y-helpers';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationContainer = (props: ComponentProps<typeof View>) => {
  const { children, style, ...restProps } = props;

  const a11ySelector = useA11ySelector('customization.container');
  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.container, match([undefined, styles.containerSM]), style];
  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={containerStyles} {...a11ySelector.props} {...restProps}>
      {children}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.QUINOA,
  },
  containerSM: {
    flexDirection: 'row',
  },
});
